import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCheck, FaMinus } from 'react-icons/fa'
import styled from 'styled-components'

interface Props {
  value?: boolean | null
}

export const SettingsBooleanValue: React.FC<Props> = ({ value }) => {
  const [t] = useTranslation()
  const isOn = Boolean(value)

  return (
    <Pill $isOn={isOn}>
      {isOn ? <FaCheck /> : <FaMinus />}
      {isOn ? t('general.yes') : t('general.no')}
    </Pill>
  )
}

const Pill = styled.span<{ $isOn: boolean }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  padding: ${({ theme }) => theme.spacing.xxs}rem ${({ theme }) => theme.spacing.sm}rem;
  border-radius: ${({ theme }) => theme.borderRadius.lg}rem;
  background: ${({ theme, $isOn }) =>
    $isOn ? theme.dashboard.positiveTint : theme.colors.neutralGray};
  color: ${({ theme, $isOn }) => ($isOn ? theme.dashboard.positive : theme.dashboard.textSubtle)};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;
  white-space: nowrap;

  svg {
    width: ${({ theme }) => theme.fontSize.px10}rem;
    height: ${({ theme }) => theme.fontSize.px10}rem;
  }
`
